import axios from "axios"

const fetchHomeContactDataRequest = () => {
	return {type: "FETCH_HOMEPAGE_CONTACT_REQUEST"}
}

const fetchHomeContactDataSuccess = (contactData) => {
	return {type: "FETCH_HOMEPAGE_CONTACT_SUCCESS", payload: contactData}
}

const fetchHomeContactDataFailure = (error) => {
	return {type: "FETCH_HOMEPAGE_CONTACT_FAILURE", payload: error}
}

export const fetchContactData = () => {
	return (dispatch) => {
		dispatch(fetchHomeContactDataRequest())
		axios.get("p/contact-us")
		.then(response => {
			const contactData = response.data
			dispatch(fetchHomeContactDataSuccess(contactData))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchHomeContactDataFailure(error))	
		})
	}
}